import React, { useEffect } from 'react';
import {
    Box,
    Grid,
    Heading,
} from '@chakra-ui/react';
import { createPortal } from 'react-dom';
import { useModal } from '../../lib';

export type ModalProps = {
    id: string
    title: string
    children: React.ReactNode
}

export const Modal: React.FC<ModalProps> = ({
    id,
    title,
    children,
}) => {
    const { closeModalById } = useModal();

    useEffect(() => {
        document.getElementById('root')!.style.position = 'fixed';
        document.getElementById('root')!.style.width = '100vw';
        document.getElementById('root')!.style.margin = 'auto';

        return () => {
            document.getElementById('root')!.style.position = 'relative';
        };
    }, []);

    return createPortal(
        <Grid
            position="fixed"
            height="100vh"
            width="100vw"
            zIndex={20}
            top={0}
            left={0}
        >
            <Grid
                margin="auto"
                maxWidth="1000px"
                width="80%"
                maxHeight="70vh"
                padding="2rem"
                background="white"
                zIndex={1}
                gap="2rem"
                overflow="scroll"
            >
                <Grid templateColumns="1fr auto">
                    <Heading size="3xl">
                        {title}
                    </Heading>
                    <Box
                        onClick={() => closeModalById && closeModalById(id)}
                        cursor="pointer"
                        fontWeight={900}
                    >
                        X
                    </Box>
                </Grid>
                {children}
            </Grid>
            <Grid
                position="fixed"
                width="100vw"
                height="100vh"
                onClick={() => closeModalById && closeModalById(id)}
                background="#000000"
                opacity="0.5"
                cursor="pointer"
            />
        </Grid>,
        document.body,
    );
};
